import { AppointmentService } from './../../services/appointment.service';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import swal from "sweetalert2";
import * as moment from 'moment-timezone';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';

@Component({
  selector: 'app-schedule-call',
  templateUrl: './schedule-call.component.html',
  styleUrls: ['./schedule-call.component.css'],
  exportAs: 'SecheduleDetailsModal'
})
export class ScheduleCallComponent implements OnInit {
  value: Date;
  minDate = new Date();
  selectedTable: any;
  scheduleDetails: any = {};
  slotValue: any;
  message: string;
  showCustomError = false;
  userRole: string;
  analystName: string;
  bookNow: boolean;
  availableSlots = [];
  private selectUndefinedOptionValue: any;
  @ViewChild('SecheduleDetailsModal') public SecheduleDetailsModal: ModalDirective;
  @Output() refreshAPI: EventEmitter<any> = new EventEmitter();
  constructor(private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private router: Router
  ) {
    this.value = new Date();
  }

  ngOnInit() {
    this.getUserRole();
  }
  showModal(analystId, analystName? : string) {
    if (analystName) {
      this.analystName = analystName;
    }
    this.initialiseModal();
    if (this.authenticationService.isLoggedIn()) {
      this.getAvilableSlots(analystId);
    } else {
      this.router.navigate(["/signin"]);
    }
  }
  initialiseModal() {
    this.showCustomError = false;
    this.bookNow = true;
    this.value = new Date();
  }
  hideModal() {
    this.SecheduleDetailsModal.hide();
  }
  getAvilableSlots(analystId) {
    this.showCustomError = false;
    const timenow = new Date();
    const timezone = 'UTC' + moment().format("Z");
    this.appointmentService.getAppointments(analystId, timezone, moment(this.value).format('YYYY-MM-DD')).subscribe(
      (response => {
        this.scheduleDetails = response;
        this.scheduleDetails['id'] = analystId;
        this.availableSlots = this.scheduleDetails.availableSlots.filter((slot) => {
          const target = new Date(slot.start.dateTime);
          if (target > timenow) {
            slot.start.dateTime = moment.parseZone(slot.start.dateTime).local().format();
            slot.end.dateTime = moment.parseZone(slot.end.dateTime).local().format();
            return slot;
          }
        });
        this.availableSlots = _.sortBy(this.availableSlots, [function(data: any) { return data.start.dateTime; }]);
        if (this.availableSlots.length > 0) {
          this.slotValue = this.availableSlots[0];
        } else {
          this.slotValue = {};
        }
        this.SecheduleDetailsModal.show();
      }),
      error => {
        if (error.status === 401) {
          // fix reditect login
          this.router.navigate(["/signin"]);
        } else {
          swal("Sorry!", error.error.error.message, "info");
        }
      }
    );
  }
  bookAppointment(id) {
    this.showCustomError = false;
    this.bookNow = false;
    const timeSlots = _.cloneDeep(this.slotValue);
    timeSlots.start.dateTime = moment.utc(this.slotValue.start.dateTime).format("YYYY-MM-DDTHH:mm:00.000000");
    timeSlots.end.dateTime = moment.utc(this.slotValue.end.dateTime).format("YYYY-MM-DDTHH:mm:00.000000");
    const requestData = {
      "slot": timeSlots,
      "message": this.message
    };
    if (this.slotValue.start && this.slotValue.end) {
      this.appointmentService.bookAnAppointment(id, requestData).subscribe((resp: any) => {
        this.SecheduleDetailsModal.hide();
        const duration = new Date(this.slotValue.end.dateTime).getTime() - new Date(this.slotValue.start.dateTime).getTime();
        this.mixpanelEventLoggingService.dispatchEvent("schedule call", {
          "Tech Analyst": this.analystName ? this.analystName : '',
          "Duration": duration / 60000 + " minutes" ,
        });
        this.mixpanelEventLoggingService.dispatchEvent("token used", {
          "No.Of Token": this.scheduleDetails.ratePerSession ? this.scheduleDetails.ratePerSession : 0,
          "Used Token For": "Schedule Call" ,
        });
        swal("Success", resp, "success");
      }, error => {
        this.bookNow = true;
        swal(error.error.error.message);
        if (error.error.error.statusCode === 402) {
          this.SecheduleDetailsModal.hide();
          this.purchaseToken();
        }
      });
    } else {
      this.showCustomError = true;
      this.bookNow = true;
    }
  }
  getUserRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  purchaseToken() {
    this.router.navigate([`${this.userRole}/purchase-tokens`], {
      queryParams: {
        'redirect-details': 'schedule_call',
        'required-tokens': this.scheduleDetails.ratePerSession || 0
      }
    });
  }

  autoResize() {
    setTimeout(function() {
      const elm = document.getElementById('message');
      elm.style.cssText = 'height: auto';
      elm.style.cssText = 'height:' + elm.scrollHeight + 'px';
    }, 0);
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-call/schedule-call.component.ts